import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
declare var $: any;
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
import { SearchBookingsComponent } from 'src/app/components/search-bookings/search-bookings.component';
import { SearchAgenciesComponent } from 'src/app/components/search-agencies/search-agencies.component';

@Component({
  selector: 'app-transfers-form',
  templateUrl: './transfers-form.component.html',
  styleUrls: ['./transfers-form.component.css']
})
export class TransfersFormComponent implements OnInit {
  private thisComponent: TransfersFormComponent;
  @ViewChild(SearchBookingsComponent) SearchBookingsComponent: any;
  @ViewChild(SearchAgenciesComponent) SearchAgenciesComponent: any;

  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables ====

  bookingSelected: any = null;
  agencySelected: any = null;
  bookings: any = [];
  tours_selecteds: any = [];

  is_booking_checked: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private bookingsService: BookingsService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private toolsService: ToolsService,
    private alert: SwalAlert,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      code: [null],
      booking_id: [null],
      operator_id: [null],
      observations: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {   
    let component_ = this.thisComponent;

    setTimeout(() => {
      this.SearchBookingsComponent.focused();
    }, 150);

    if (this.isEdit) {
      this.editData();
    }

    (<any>$('[data-toggle="tooltip"]')).tooltip();
    this.navigationTrackerService.initializeMenu(this.route);
  }

  editData() {
    this.bookingsService.getTransferData(this.checkId).subscribe({
      next: (data: any) => {
        let book = data.data.book;
        this.item.patchValue({
          code: book.code,
          operator_id: book.operator_id,
          booking_id: book.booking_id,
          observations: book.observations
        });  
        console.log(data);      
        this.selectedBookingsSearch(book.origintransfer);
        this.selectedAgenciesSearch(book.agency_data);
        // bookings ======
        this.bookings = book.program_transfer;
        this.is_booking_checked = true;
        for(let i in this.bookings){
          this.bookings[i].is_selected = true;
        }
        this.tours_selecteds = this.bookings;
        // set checked
        // setTimeout(() => {
        //   for (let index in this.bookings) {
        //     (<any>$('#booking_' + this.bookings[index].id)).attr(
        //       'checked',
        //       'checked'
        //     );
        //   }
        // }, 50);
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  selectedBookingsSearch(item_: any) {
    this.bookingSelected = item_;
    this.item.patchValue({
      booking_id: this.bookingSelected.id
    });
    if(!this.isEdit){
      this.bookingData(this.bookingSelected.id);
    }
  }

  removeBookings() {
    this.bookingSelected = null;
    this.item.patchValue({
      booking_id: null
    });
    setTimeout(() => {
      this.SearchBookingsComponent.focused();
    }, 150);
  }

  selectedAgenciesSearch(item_: any) {
    this.agencySelected = item_;
    this.item.patchValue({
      operator_id: this.agencySelected.id
    });
  }

  removeAgencies() {
    this.agencySelected = null;
    this.item.patchValue({
      operator_id: null
    });
    setTimeout(() => {
      this.SearchAgenciesComponent.focused();
    }, 150);
  }

  bookingData(booking_id: any) {
    this.bookingsService.getTransferData(booking_id).subscribe({
      next: (data: any) => {
        let result_ = data.data;
        let arr_bookings = result_.tours;
        for (let i in arr_bookings) {
          arr_bookings[i].is_selected = false;
        }
        this.bookings = arr_bookings;
      }
    });
  }

  selectedBooking(booking: any, index_booking: any) {
    // console.log((<any>$('#booking_'+booking_id)).is(":checked"));
    // console.log(booking);
    let validate_ = this.toolsService.notExistObjInArr(
      booking,
      this.tours_selecteds
    );
    if (validate_) {
      this.bookings[index_booking].is_selected = true;
      this.tours_selecteds.push(booking);
    } else {
      this.bookings[index_booking].is_selected = false;
      let index = this.tours_selecteds.indexOf(booking);
      this.tours_selecteds.splice(index, 1);
    }
  }

  changePriceCorporate(param: any, booking: any): void {
    let value_ = param.value;
    let index_booking = this.bookings.indexOf(booking);
    let index_tourselected = this.tours_selecteds.indexOf(booking);
    if (!_.isNaN(value_ * 1)) {
      this.bookings[index_booking].price_corporate = value_;
      this.tours_selecteds[index_tourselected].price_corporate = value_;
    }
  }

  changeDelegatedPayment(param: any, booking: any): void {
    let value_ = param.value;
    let index_booking = this.bookings.indexOf(booking);
    let index_tourselected = this.tours_selecteds.indexOf(booking);
    if (!_.isNaN(value_ * 1)) {
      this.bookings[index_booking].delegated_payment = value_;
      this.tours_selecteds[index_tourselected].delegated_payment = value_;
    }
  }

  changeObservation(param: any, booking: any): void {
    let value_ = param.value;
    let index_booking = this.bookings.indexOf(booking);
    let index_tourselected = this.tours_selecteds.indexOf(booking);
    this.bookings[index_booking].observation = value_;
    this.tours_selecteds[index_tourselected].observation = value_;
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    if (this.validate()) {
      let data: any = {};
      data.book = this.item.value;
      data.tours = this.tours_selecteds;
      if (this.isEdit) {
        this.bookingsService.updateTransfer(this.checkId, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.detail(this.checkId);
            // this.cancel();
          }
        });
      } else {
        this.bookingsService.saveTransfers(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.detail(data.data.id);
            // this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (this.bookingSelected == null) {
      this.alertifyMsg.warning(
        'Debe seleccionar la reserva para cargar los tours a traspasar'
      );
      this.SearchBookingsComponent.focused();
      return false;
    }

    if (this.agencySelected == null) {
      this.alertifyMsg.warning('Debe seleccionar la agencia operadora.');
      this.SearchAgenciesComponent.focused();
      return false;
    }
    if (this.tours_selecteds.length == 0) {
      this.alert.msgWarning(
        'Debe seleccionar al menos un programa para poder registrar el traspaso'
      );
      return false;
    }

    return true;
  }

  detail(id:any) {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/traspasos/detalle',
      id
    ]);
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reservas/traspasos/lista']);
  }
}
